(ns common.opensearch.utils
  (:require [clojure.string :as string]))

(defn field-path->alias
  "Convert a logical field path (keyword or vector of keywords) into a unique alias
   that is stable and safe to use in flat.* / labels.* field names."
  [field-path]
  (let [ks (if (sequential? field-path)
             field-path
             [field-path])]
    (->> ks
         (map (fn [k]
                (cond (string? k)
                      k
                      :else
                      (if-let [ns (namespace k)]
                        (str ns "-" (name k))
                        (name k)))))
         (string/join "-"))))

(defn field-path->flat-alias
  "Given a logical field path, produce a unique flat alias string.

   Examples:
   [:screening-profile/first-name]
   -> \"flat.screening-profile-first-name\"

   [:screening-profile/updated-by :account/first-name]
   -> \"flat.screening-profile-updated-by-account-first-name\""
  [field-path]
  (str "flat." (field-path->alias field-path)))

(defn field-path->labels-alias
  "Given a logical field path, produce a unique labels alias string.

   Examples:
   [:screening-profile/first-name]
   -> \"labels.screening-profile-first-name_en\"

   [:screening-profile/updated-by :account/first-name]
   -> \"labels.screening-profile-updated-by-account-first-name_en\""
  ([field-path]
   (field-path->labels-alias field-path "en"))
  ([field-path lang]
   (str "labels." (field-path->alias field-path) "_" lang)))

(defn text-sort-fields
  "The fields to sort a text value on, in order of priority. `field` is a flat or
   labels alias. The `.lower` subfield orders without regard to case, so \"abc\"
   comes before \"Abd\". The `.keyword` subfield comes second. It orders the values
   that differ only by case, and it keeps the case-sensitive order for a field of
   an index that has no `.lower` subfield. The index template maps both subfields
   for every string. See backend.search.dedicated.template."
  [field]
  [(str field ".lower")
   (str field ".keyword")])

(defn ag->os-sort-model
  "Convert a ag-grid sort model into an OpenSearch sort vector.

   `sort-model` is the ag-grid sort model (vector of maps).
   `tenant-schema` is used to resolve field data types so that we can decide
   whether to sort on the base field or its `.keyword` subfield."
  [sort-model tenant-schema]
  (->> sort-model
       (keep (fn [{:keys [colId sort sortIndex]}]
               (when (or sort sortIndex)
                 {:column     colId
                  :sort       sort
                  :sort-index sortIndex})))
       (sort-by :sort-index)
       (mapv (fn [{:keys [column sort]}]
               {column {"order" sort}}))))
